import { useEffect, useRef, useState } from 'react';
import { subscribeData } from '../services/data-service';
import { List, AutoSizer } from 'react-virtualized';
import ItemRessource from './item-ressource';
import './liste.scss';

const Liste = ({ tags }) => {

    const listeRef = useRef();
    const [data, setData] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    
    useEffect(() => {
        const unsubscribe = subscribeData(onData);
        return function cleanup() {
            unsubscribe(onData);
        }
    }, []);

    const onData = (newData) => {

        if(!newData) return;

        const selectedItem = newData.filter(item => item.selected);

        if(selectedItem){
            setCurrentIndex(newData.indexOf(selectedItem[0]));
        }

        if(listeRef.current) listeRef.current.forceUpdateGrid();
        setData(newData);
    }

    const rowRenderer = ({index, isScrolling, isVisible, key, parent, style}) => {
        const item = data[index];
        return (
            <ItemRessource key={item?.id + '-' + item?.idgis + "-" + index} style={style} data={item} tags={tags} />
        );
    }

    if(!data) return false;

    return(
        <div className="data-map-list">
            <AutoSizer className="data-map-list-container">
                {({width, height}) => (
                    <List 
                        ref={listeRef} 
                        height={height} 
                        width={width} 
                        overscanRowCount={5} 
                        rowCount={data.length} 
                        rowHeight={120} 
                        rowRenderer={rowRenderer} 
                        scrollToAlignment={'center'} 
                        scrollToIndex={currentIndex} 
                    />
                )}
            </AutoSizer>
        </div>
    )
};

export default Liste;